import { createSlice } from "@reduxjs/toolkit";

const Id = await localStorage.getItem("secretKeyesforzado7");

// console.log(Id);

const initialState = {
  mode: "dark",
  userId: Id,
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
  },
});

export const { setMode } = globalSlice.actions;

export default globalSlice.reducer;
